import { render, staticRenderFns } from "./ContactTypeCustomFields.vue?vue&type=template&id=33407129&scoped=true&"
import script from "./ContactTypeCustomFields.vue?vue&type=script&lang=js&"
export * from "./ContactTypeCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./ContactTypeCustomFields.vue?vue&type=style&index=0&id=33407129&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33407129",
  null
  
)

export default component.exports